/* ============================================================
   wishlist.js — templates/page.wishlist.json (sections/wishlist-page.liquid)
   ------------------------------------------------------------
   Reads the same "ghonche_wishlist" localStorage key (array of product
   handles) that main.js's sitewide heart-toggle uses. Ported from the
   static build's js/wishlist.js — same markup, same "Move to Cart" flow
   via window.GhoncheCart. Only real change: instead of looking products
   up in a deleted catalog.json, each saved handle is fetched from
   Shopify's real per-product endpoint (/products/{handle}.js).
   ============================================================ */
(function () {
  "use strict";

  var WISHLIST_KEY = "ghonche_wishlist";

  function fmt(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.GHONCHE_MONEY_FORMAT);
    }
    return "Rs. " + Math.round((Number(cents) || 0) / 100).toLocaleString("en-PK");
  }

  function getCdnUrl(url, width) {
    if (!url || typeof url !== "string") return url;
    var parts = url.split("?");
    var q = (parts[1] || "") ? parts[1] + "&width=" + width : "width=" + width;
    return parts[0] + "?" + q;
  }

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || "[]"); } catch (e) { return []; }
  }

  function saveWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function cardHTML(p) {
    var variant = p.variants[0];
    var href = "/products/" + p.handle;
    var price = Math.round(Number(variant.price) * 100);
    var was = variant.compare_at_price ? Math.round(Number(variant.compare_at_price) * 100) : 0;
    var off = was > price ? Math.round((1 - price / was) * 100) : 0;
    var img0 = (p.images && p.images[0]) || "";

    var badge = "";
    if (!variant.available) badge = '<span class="card__badge card__badge--po">Sold Out</span>';
    else if (off > 0) badge = '<span class="card__badge">' + off + '% OFF</span>';

    var priceHTML = off > 0
      ? "<s>" + esc(fmt(was)) + '</s><strong class="is-sale">' + esc(fmt(price)) + "</strong>"
      : "<strong>" + esc(fmt(price)) + "</strong>";

    var rd = window.GhoncheRatings ? window.GhoncheRatings.get(p.handle) : { rating: 4.8, reviews: 0 };

    return (
      '<article class="card" data-wish-card="' + esc(p.handle) + '">' +
        badge +
        '<div class="card__media"><a href="' + esc(href) + '">' +
          '<img src="' + esc(getCdnUrl(img0, 600)) + '" alt="' + esc(p.title) + '" width="900" height="1200" loading="lazy"></a>' +
        "</div>" +
        '<div class="card__body">' +
          '<h3 class="card__title"><a href="' + esc(href) + '">' + esc(p.title) + "</a></h3>" +
          '<p class="card__price">' + priceHTML + "</p>" +
          '<p class="card__proof">' + (window.GhoncheRatings ? window.GhoncheRatings.starsHTML(rd.rating) : "") + " " + rd.rating + " (" + rd.reviews + ")</p>" +
          '<div class="wishlist-card__actions">' +
            '<button type="button" class="btn btn--primary wishlist-card__move" data-wish-move data-variant-id="' + esc(variant.id) + '" data-handle="' + esc(p.handle) + '"' + (!variant.available ? " disabled" : "") + '>' + (variant.available ? "Move to Cart" : "Sold Out") + '</button>' +
            '<button type="button" class="wishlist-card__remove" data-wish-remove="' + esc(p.handle) + '">Remove</button>' +
          "</div>" +
        "</div>" +
      "</article>"
    );
  }

  function fetchProduct(handle) {
    return fetch("/products/" + handle + ".js").then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }

  function render() {
    var grid = document.querySelector("[data-wishlist-grid]");
    var empty = document.querySelector("[data-wishlist-empty]");
    var countEl = document.querySelector("[data-wishlist-count]");
    if (!grid) return;

    var handles = getWishlist();
    if (countEl) countEl.textContent = handles.length ? "(" + handles.length + ")" : "";

    if (!handles.length) {
      grid.hidden = true;
      grid.innerHTML = "";
      if (empty) empty.hidden = false;
      return;
    }

    Promise.all(handles.map(fetchProduct).concat([window.GhoncheRatings ? window.GhoncheRatings.preload() : Promise.resolve()])).then(function (results) {
      var products = results.slice(0, handles.length).filter(Boolean);

      if (!products.length) {
        grid.hidden = true;
        if (empty) empty.hidden = false;
        return;
      }

      if (empty) empty.hidden = true;
      grid.hidden = false;
      grid.innerHTML = products.map(cardHTML).join("");
    });
  }

  document.addEventListener("click", function (e) {
    var rem = e.target.closest("[data-wish-remove]");
    if (rem) {
      var list = getWishlist().filter(function (h) { return h !== rem.dataset.wishRemove; });
      saveWishlist(list);
      render();
      return;
    }
    var move = e.target.closest("[data-wish-move]");
    if (move && !move.disabled) {
      if (window.GhoncheCart) {
        window.GhoncheCart.addToCart(move.dataset.variantId, 1).then(function () {
          window.GhoncheCart.openDrawer();
        });
      }
      var list = getWishlist().filter(function (h) { return h !== move.dataset.handle; });
      saveWishlist(list);
      render();
      return;
    }
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", render);
  } else {
    render();
  }
})();
